module.exports = __webpack_public_path__ + "img/click.adc1c101.svg";